import {FC, ReactNode} from "react";
import {BentoIntelligenceProvider} from "../BentoIntelligenceContext";
import {BentoPersonaProvider} from "../BentoPersonaContext";
import {BentoViewModeProvider} from "../BentoViewModeContext";
import BentoDemoSidebar from "./BentoDemoSidebar";
import BentoNavHeader from "./BentoNavHeader";
import "../bento-coach-insights.scss";

interface BentoShellProps {
    children: ReactNode;
}

// Persistent layout shell for all PAR Intelligence (Bento) routes. Rendering the
// sidebar and top header here — outside the routed <Switch> — keeps them mounted
// across page navigation, so only the inner content swaps and the shell no longer
// flashes when a lazily-loaded page suspends.
//
// BentoIntelligenceProvider owns the PAR Intelligence drawer instance so both the
// nav header and insight cards can open it (with or without a pre-loaded workflow)
// without passing callbacks through the tree.
const BentoShell: FC<BentoShellProps> = ({children}) => (
    <BentoPersonaProvider>
        <BentoIntelligenceProvider>
            <BentoViewModeProvider>
                <div className="bento-demo-shell">
                    <BentoNavHeader />

                    <div className="bento-demo-page">
                        <BentoDemoSidebar />

                        <div className="bento-demo-main">
                            <div className="bento-demo-content">{children}</div>
                        </div>
                    </div>
                </div>
            </BentoViewModeProvider>
        </BentoIntelligenceProvider>
    </BentoPersonaProvider>
);

export default BentoShell;
